<template>
  <div class="animated-phone">
    <img class="animated-phone-box" src="@/assets/images/phone-transparent-2x.png" />
    <img class="animated-phone-layer-1 animated-phone-layer" src="@/assets/images/phone-transparent-1-layer.png" />
    <img class="animated-phone-layer-2 animated-phone-layer" src="@/assets/images/phone-transparent-2-layer.png" />
    <img class="animated-phone-layer-3 animated-phone-layer" src="@/assets/images/phone-transparent-3-layer.png" />
    <img class="animated-phone-layer-4 animated-phone-layer" src="@/assets/images/phone-transparent-4-layer.png" />
    <img class="animated-phone-layer-5 animated-phone-layer" src="@/assets/images/phone-transparent-5-layer.png" />
  </div>
</template>

<script>
export default {
  mounted () {
    this.$gsap.to('.animated-phone-box', {
      y: 0,
      scrollTrigger: {
        trigger: '.animated-phone-box',
        start: 'top bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.animated-phone-layer-1', {
      x: 600,
      opacity: 0,
      scrollTrigger: {
        trigger: '.animated-phone-layer-1',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1
      }
    })

    this.$gsap.from('.animated-phone-layer-2', {
      x: -600,
      opacity: 0,
      scrollTrigger: {
        trigger: '.animated-phone-layer-2',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 1.5
      }
    })

    this.$gsap.from('.animated-phone-layer-3', {
      x: 600,
      opacity: 0,
      scrollTrigger: {
        trigger: '.animated-phone-layer-3',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 2
      }
    })

    this.$gsap.from('.animated-phone-layer-4', {
      x: -600,
      opacity: 0,
      scrollTrigger: {
        trigger: '.animated-phone-layer-4',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 2.5
      }
    })

    this.$gsap.from('.animated-phone-layer-5', {
      x: 600,
      opacity: 0,
      scrollTrigger: {
        trigger: '.animated-phone-layer-5',
        start: '+=50 bottom',
        end: '+=150',
        scrub: 3
      }
    })
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .animated-phone {
    position: relative;
    overflow: hidden;

    &-box {
      transform: translateY(40px);
    }

    &-layer {
      position: absolute;
      z-index: 1;
      width: 100%;
    }

    &-layer-1 {
      top: 22%;
      right: 7%;
      @media #{$desktop} {top: 22%;}
    }

    &-layer-2 {
      top: 32%;
      left: 7%;
      @media #{$desktop} {top: 32%;}
    }

    &-layer-3 {
      top: 46%;
      right: 7%;
      @media #{$desktop} {top: 46%;}
    }

    &-layer-4 {
      top: 72%;
      left: 7%;
      @media #{$desktop} {top: 73%;}
    }

    &-layer-5 {
      top: 91%;
      right: 7%;
      @media #{$desktop} {top: 93%;}
    }

    &-box {
      position: relative;
      z-index: 3;
      width: 100%;
      display: block;
    }
  }
</style>
